import axios from 'axios';
import { push } from 'connected-react-router';
import { IdentityUrl } from '../../config';
import { exportToSpreadsheet, cortarArreglo } from '../../helpers/commons';
import { closeAdvancedSearch, closeMessageBox, openAdvancedSearch, openMessageBox } from '../main/actions';
import { CLEAN_FORM, RECEIVE_LIST, REQUEST_LIST, ERROR_LIST, SET_ENTITY, SET_ERROR, SET_MASK, SET_ORDER, SET_PAGE, SET_PAGE_SIZE, SET_SELECTED_ROW, SET_STATE_FORM, UPDATE_FIELD_ENTITY, UPDATE_FIELD_FILTER, UPDATE_TABLE_COLUMN } from './types';

export const getRol = (rolId) => async (dispatch, getState) => {
    if (rolId === 0) return;
    try {
        dispatch({ type: SET_MASK, loading: true });

        let payload = {
            // ...response.data,
        };
        console.log(payload);

        dispatch({ type: SET_ENTITY, payload });
    } catch (error) {
        if (error.response.status === 404) {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'error',
                    message: 'No se encontro el registro solicitado.',
                    callback: () => {
                        dispatch(closeMessageBox());
                        dispatch(
                            push({
                                pathname: `/roles`,
                                search: getState().router.location.search,
                                hash: getState().router.location.hash,
                            }),
                        );
                    },
                }),
            );
        } else {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'error',
                    message: (error.response.data.eventLogId === 0 ? error.response.data.message : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message,
                    callback: () => dispatch(closeMessageBox()),
                }),
            );
        }
    } finally {
        dispatch({ type: SET_MASK, loading: false });
    }
};

export const btnSearch = () => (dispatch) => {
    dispatch(setPage(0));
    dispatch(onRolesList());
};

export const onRolesList = () => async (dispatch, getState) => {
    if (getState().roles.store.source) {
        getState().roles.store.source.cancel();
    }

    // if (getState().roles.filters.aplicacionClienteId === '') {
    //     dispatch(
    //         openMessageBox({
    //             button: 'ok',
    //             icon: 'warning',
    //             message: 'Debe una Aplicacion..',
    //             callback: () => dispatch(closeMessageBox()),
    //         }),
    //     );
    //     return;
    // }

    let source = axios.CancelToken.source();

    dispatch({ type: REQUEST_LIST, source });

    try {
        let url = `${IdentityUrl}/api/v1/usuarios/listRol?` + `pageSize=${getState().roles.store.pageSize}&start=${getState().roles.store.start}`;
        let response = await axios.get(encodeURI(url), { cancelToken: source.token });
        let data = response.data;
        dispatch({ type: RECEIVE_LIST, total: data.length, payload: data });

        if (data.length === 0) {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'warning',
                    message: 'No existe Registro para esta consulta',
                    callback: () => dispatch(closeMessageBox()),
                }),
            );
            return;
        }
    } catch (error) {
        console.log(error);
        dispatch({ type: ERROR_LIST });
        if (!axios.isCancel(error)) {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'error',
                    message: (error.response.data.eventLogId === 0 ? error.response.data.message : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message,
                    callback: () => dispatch(closeMessageBox()),
                }),
            );
        }
    }
};

export const btnExport = () => async (dispatch, getState) => {
    if (getState().roles.store.data.length === 0) {
        dispatch(
            openMessageBox({
                button: 'ok',
                icon: 'warning',
                message: 'No hay información para exportar.',
                callback: () => dispatch(closeMessageBox()),
            }),
        );
        return;
    }

    try {
        dispatch({ type: SET_MASK, loading: true });

        let head = getState().roles.table.columns;
        console.log('Exportando...');
    } catch (error) {
        dispatch(
            openMessageBox({
                button: 'ok',
                icon: 'error',
                message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message,
                callback: () => dispatch(closeMessageBox()),
            }),
        );
    } finally {
        setTimeout(() => {
            dispatch({ type: SET_MASK, loading: false });
        }, 1000);
    }
};

export const btnSave = () => (dispatch, getState) => {
    if (getState().roles.entity.nombre === '') {
        dispatch(
            openMessageBox({
                button: 'ok',
                icon: 'warning',
                message: 'Debe ingresar un nombre..',
                callback: () => dispatch(closeMessageBox()),
            }),
        );
        return;
    }

    if (getState().roles.entity.nombre === '') {
        dispatch({ type: SET_ERROR, key: 'nombre', error: 'Este campo es requerido' });
    }

    if (getState().roles.errors.nombre !== '') {
        return;
    }

    dispatch(
        openMessageBox({
            button: 'yesno',
            icon: 'question',
            message: '¿Desea guardar la información?',
            callback: (btn) => {
                if (getState().roles.entity.roId === '') {
                    dispatch(onSave(btn));
                } else {
                    dispatch(onUpdate(btn));
                }
            },
        }),
    );
};

export const btnDelete = () => (dispatch) => {
    dispatch(
        openMessageBox({
            button: 'yesno',
            icon: 'question',
            message: 'Se elimanara el registro permanentemente. ¿Desea continuar?',
            callback: (btn) => dispatch(onDelete(btn)),
        }),
    );
};

export const onSave = (btn) => async (dispatch, getState) => {
    dispatch(closeMessageBox());
    if (btn === 'yes') {
        try {
            dispatch({ type: SET_MASK, loading: true });
            console.log('guardando...');
        } catch (error) {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'error',
                    message: (error.response.data.eventLogId === 0 ? error.response.data.message : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message,
                    callback: () => dispatch(closeMessageBox()),
                }),
            );
        } finally {
            dispatch({ type: SET_MASK, loading: false });
        }
    }
};

export const onUpdate = (btn) => async (dispatch, getState) => {
    dispatch(closeMessageBox());
    if (btn === 'yes') {
        try {
            dispatch({ type: SET_MASK, loading: true });
            console.log('actualizando...');
        } catch (error) {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'error',
                    message: (error.response.data.eventLogId === 0 ? error.response.data.message : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message,
                    callback: () => dispatch(closeMessageBox()),
                }),
            );
        } finally {
            dispatch({ type: SET_MASK, loading: false });
        }
    }
};

export const onDelete = (btn) => async (dispatch, getState) => {
    dispatch(closeMessageBox());

    if (btn === 'yes') {
        try {
            dispatch({ type: SET_MASK, loading: true });
            console.log('eliminando...');
        } catch (error) {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'error',
                    message: (error.response.data.eventLogId === 0 ? error.response.data.message : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message,
                    callback: () => dispatch(closeMessageBox()),
                }),
            );
        } finally {
            dispatch({ type: SET_MASK, loading: false });
        }
    }
};

export const cleanForm = () => ({ type: CLEAN_FORM });

export const onUpdateColumn = (column) => (dispatch, getState) => {
    let columns = getState().roles.table.columns.map((item) => {
        if (item.dataKey !== column.dataKey) {
            return item;
        }

        return {
            ...item,
            width: column.width,
        };
    });

    dispatch({ type: UPDATE_TABLE_COLUMN, columns });
};

export const onUpdateFieldEntity = (key, value) => (dispatch) => {
    dispatch({ type: UPDATE_FIELD_ENTITY, key, value });

    if (key === 'nombre') {
        dispatch({ type: SET_ERROR, key, error: '' });
    }
};

export const onUpdateFieldFilter = (key, value) => (dispatch, getState) => {
    dispatch({ type: UPDATE_FIELD_FILTER, key, value });

    dispatch({ type: RECEIVE_LIST, total: 0, payload: [] });
};

export const setFormState = (formState, id) => (dispatch, getState) => {
    switch (formState) {
        case 'edit':
            if (id !== getState().roles.entity.rolId) {
                dispatch(getRol(id));
            }
            break;
        case 'new':
            dispatch(cleanForm());
            break;
        case 'search':
            dispatch(cleanForm());
            break;
        case 'view':
            if (id !== getState().roles.entity.rolId) {
                dispatch(getRol(id));
            }
            break;
        default:
            break;
    }

    dispatch({ type: SET_STATE_FORM, formState });
};

export const setOrder = (order, orderBy) => ({ type: SET_ORDER, order, orderBy });

export const setPage = (page) => ({ type: SET_PAGE, page });

export const setPageSize = (pageSize) => ({ type: SET_PAGE_SIZE, pageSize });

export const setSelectedRow = (selected) => ({ type: SET_SELECTED_ROW, selected });
